import { render, staticRenderFns } from "./HomeCarousel.vue?vue&type=template&id=4ecdb1f0&"
import script from "./HomeCarousel.vue?vue&type=script&lang=js&"
export * from "./HomeCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HomeCarousel.vue?vue&type=style&index=0&id=4ecdb1f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports